module.exports = __webpack_public_path__ + "img/port_centrion_smart.677bd210.png";